import React, { memo } from 'react'
import { DISPLAY } from 'constants/display'

interface IInsuranceSectionProps {
  title: string
  rows: {
    label?: string
    value?: string | null
  }[][]
}

const InsuranceSection: React.FunctionComponent<IInsuranceSectionProps> = memo(
  ({ rows, title }) => (
    <>
      <h3>{title}</h3>
      {rows.map(items => {
        const key = `row-${items.map(({ label }) => label).join('-')}`
        return (
          <div key={key} className='row no-gutter' data-test='row-wrap'>
            {items.map(({ label, value }) => (
              <div className='col-xs-5' key={label}>
                <div className='row no-gutter'>
                  <small>{label}</small>
                  <p data-test={`value:${label}`}>{value || DISPLAY.empty}</p>
                </div>
              </div>
            ))}
          </div>
        )
      })}
    </>
  )
)
export default InsuranceSection
